import * as React from "react";
const SvgCalculationTwoBar = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "40px", viewBox: "0 -960 960 960", width: "40px", fill: "#FFFFFF", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M200-160v-240h106.67v240H200Zm246.67 0v-440h106.66v440H446.67Z" }));
export default SvgCalculationTwoBar;
